import React from 'react';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import { Box, Button, Card, CardContent, Grid, Link, Paper, Typography } from '@mui/material';
import SpeakerIcon from '../../icons/SpeakerIcon';
import { useAuth } from '../../hooks/useAuth';
import parse from 'html-react-parser';

const CUSTOMER_SUPPORT_LIST = [
    {
        id: Math.random(),
        heading: 'Entity Formation',
        para: 'We can help you file an amendment, process your renewal, file for dissolution, and more!',
        icon: '1.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11479957-entity-formation',
        customerLabels: [
            { label: 'Amendment', value: 'Biz Help' },
            { label: 'Dissolution', value: 'Biz Help' },
            { label: 'Billing', value: 'Billing' },
            { label: 'Renewal', value: 'Renewals' },
            { label: 'Other', value: 'Support' },
        ],
    },
    {
        id: Math.random(),
        heading: 'Registered Agent',
        para: 'Request physical mail delivery, track expected mail, discuss billing options, and process other requests.',
        icon: '2.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11740716-registered-agent',
        customerLabels: [
            { label: 'Request physical mail forwarding', value: 'RA Support' },
            { label: 'Mail tracking', value: 'RA Support' },
            { label: 'Billing', value: 'Billing' },
            { label: 'Amazon questions', value: 'RA Support' },
            { label: 'Cancelation', value: 'Billing' },
            { label: 'Other', value: 'RA Support' },
        ],
    },
    {
        id: Math.random(),
        heading: 'Branded Domain & Email',
        para: 'We can provide you with technical support, billing options, ownership transfers, and more.',
        icon: '3.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11740670-branded-domain-email',
        customerLabels: [
            { label: 'Technical issues', value: 'Support' },
            { label: 'Billing', value: 'Support' },
            { label: 'Ownership questions', value: 'Support' },
            { label: 'Cancelation', value: 'Billing' },
            { label: 'Other', value: 'Support' },
        ],
    },
    {
        id: Math.random(),
        heading: 'Business Bank Account',
        para: 'All business credit related questions should be directed to our fulfillment provider, Relay:',
        paraData: `<ul>
            <li><a href="mailto:support@relayfi.com">support@relayfi.com</a></li>
            <li><a href="tel:+18882059304">888-205-9304</a></li>
            </ul>
        `,
        icon: '4.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11740554-business-bank-account',
        customerLabels: '',
        hideSupportButton: true,
    },
    {
        id: Math.random(),
        heading: 'Business Credit',
        para: 'All business credit related questions should be directed to our fulfillment provider, Fundability:',
        paraData: `<ul>
            <li><a href="mailto:advisor@fundability.com">advisor@fundability.com</a></li>
            <li><a href="tel:+18777912790">877-791-2790</a></li>
            </ul>
        `,
        icon: '5.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11740704-business-credit',
        customerLabels: '',
        hideSupportButton: true,
    },
    {
        id: Math.random(),
        heading: 'Bankable Website',
        para: 'Request updates or edits to your website, discuss your billing options, and process other requests.',
        icon: '6.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11740652-bankable-website',
        customerLabels: [
            { label: 'Updates and edits', value: 'Support' },
            { label: 'Billing', value: 'Billing' },
            { label: 'Cancelation', value: 'Billing' },
            { label: 'Other', value: 'Support' },
        ],
    },
    {
        id: Math.random(),
        heading: 'Estate Plan',
        para: 'Get answers to questions about your plan, receive technical support for your portal, discuss finalization options, and more!',
        icon: '9.png',
        hyperlink: 'https://help.primecorporateservices.com/en/collections/11522395-estate-planning',
        customerLabels: [
            { label: 'Plan questions', value: 'Support' },
            { label: 'Technical support', value: 'Support' },
            { label: 'Cancelation', value: 'Billing' },
            { label: 'Other', value: 'Support' },
        ],
    },
    {
        id: Math.random(),
        heading: 'Tax Services',
        para: 'Request assistance regarding your tax service.',
        icon: '2.jpg',
        hyperlink: 'https://help.primecorporateservices.com/en/articles/14809577-about-prime-s-tax-services',
        customerLabels: '',
        hideSupportButton: false,
    },
    {
        id: Math.random(),
        heading: 'General Support',
        para: 'For all other questions, submit a support request or contact us directly:',
        paraData: ` <ul>
            <li><a href="mailto:support@primecorporateservices.com">support@primecorporateservices.com</a></li>
            <li><a href="tel:+18555774639">855-577-4639</a></li>
            </ul>
        `,
        icon: '8.png',
        hyperlink: 'https://help.primecorporateservices.com/en/articles/10697986-support-guide-who-to-contact-at-prime',
        customerLabels: '',
        hideSupportButton: false,
    },
];
function CustomerSupport() {
    const { getUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();

    const handleRequestSupport = (value) => {
        // createCase({
        //     subject: `Customer Support: ${value?.heading}`,
        //     title: `Customer Support`,
        //     subTitle: 'Add reason to Customer Support, that will help the agent.',
        //     recordType: 'General Case',
        //     accountId: userDetails?.contact?.accountId,
        // });
        createCase({
            title: `Request support—${value?.heading}`,
            subTitle: 'Tell us a little more about how we can help you and an agent will contact you shortly!',
            subject: `Request support: ${value?.heading}`,
            recordType: 'General Case',
            accountId: userDetails?.contact?.accountId,
            hideCompanyField: false, // hide company field
            showCustomerField: false, // show customer field
            type: 'Support',
        });
    };

    const createCase = (detail) => {
        const event = new CustomEvent('createCase', {
            detail: detail,
        });

        document.dispatchEvent(event);
    };

    // if (true) {
    //     return skeleton;
    // }
    return (
        <MainContainer>
            <MainHeading gutterBottom>Customer Support</MainHeading>
            <ParaText>Need assistance with your account or services? Our support team is ready to help. Reach out with any questions, and we’ll make sure you get the answers you need.</ParaText>

            <Grid container spacing={2} marginTop={'1rem'}>
                {CUSTOMER_SUPPORT_LIST.map((cItem, index) => {
                    const parseParaDataText = cItem.paraData ? parse(cItem.paraData) : '';
                    return (
                        <Grid
                            key={cItem.id}
                            item
                            xs={12}
                            md={6}
                            lg={6}
                            sx={{
                                // '@media (min-width:601px) and (max-width:800px)': {
                                //     maxWidth: '100%',
                                //     flexBasis: '100%',
                                // },
                                '@media (min-width:1000px) and (max-width:1130px)': {
                                    maxWidth: '100%',
                                    flexBasis: '100%',
                                },
                                '@media (min-width:1200px) and (max-width:1260px)': {
                                    maxWidth: '50%',
                                    flexBasis: '50%',
                                },
                                '@media (min-width:1665px)': {
                                    maxWidth: '33.33%',
                                    flexBasis: '33.33%',
                                },
                            }}
                        >
                            <Card
                                sx={
                                    {
                                        // minHeight: '160px',
                                        // maxHeight: '160px',
                                    }
                                }
                            >
                                <CardContent
                                    sx={(theme) => ({
                                        display: 'flex',
                                        overflow: 'auto',
                                        '&:last-child': {
                                            padding: '1rem',
                                        },
                                        [theme.breakpoints.down('sm')]: {
                                            flexDirection: 'column',
                                            overflow: 'auto',
                                        },
                                        '@media (min-width:601px) and (max-width:800px)': {
                                            flexDirection: 'column',
                                            overflow: 'auto',
                                        },
                                    })}
                                >
                                    <Box
                                        display={'flex'}
                                        justifyContent={{ xs: 'start', sm: 'center' }}
                                        alignItems={'start'}
                                        sx={{
                                            '@media (min-width:601px) and (max-width:800px)': {
                                                justifyContent: 'start',
                                            },
                                        }}
                                    >
                                        <Box
                                            component={'img'}
                                            variant="outlined"
                                            borderRadius={'50%'}
                                            border={(theme) => `1px solid ${theme.palette.border.neutralPrimary}`}
                                            minHeight={{ xs: '4.5rem' }}
                                            minWidth={{ xs: '4.5rem' }}
                                            height={{ xs: '4.5rem' }}
                                            width={{ xs: '4.5rem' }}
                                            padding={'0.5rem'}
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            marginTop={{ xs: '0', sm: '0.125rem' }}
                                            src={`/images/imgs/${cItem.icon}`}
                                            alt=""
                                            sx={{
                                                '@media (min-width:601px) and (max-width:800px)': {
                                                    minHeight: '4.5rem',
                                                    minWidth: '4.5rem',
                                                    height: '4.5rem',
                                                    width: '4.5rem',
                                                    marginTop: '0rem',
                                                },
                                            }}
                                        ></Box>
                                    </Box>
                                    <Box
                                        marginLeft={{ xs: '0rem', sm: '1rem' }}
                                        marginTop={{
                                            xs: '1rem',
                                            sm: '0rem',
                                        }}
                                        flex={1}
                                        sx={{
                                            '@media (min-width:601px) and (max-width:800px)': {
                                                marginTop: '1rem',
                                                marginLeft: '0rem',
                                            },
                                        }}
                                    >
                                        <Typography
                                            component={'h2'}
                                            variant="paraText1"
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1, // Limit to 2 lines
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {cItem.heading}
                                        </Typography>

                                        <Box
                                            sx={(theme) => ({
                                                minHeight: { xs: 'unset', sm: '115px' },
                                                maxHeight: { xs: 'unset', sm: '115px' },

                                                '@media (min-width:601px) and (max-width:700px)': {
                                                    minHeight: 'unset',
                                                    maxHeight: 'unset',
                                                },
                                            })}
                                        >
                                            <Typography
                                                component={'p'}
                                                variant="paraText3"
                                                sx={(theme) => ({
                                                    [theme.breakpoints.up('sm')]: {
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 5, // Limit to 4 lines
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    },
                                                })}
                                            >
                                                {cItem.para}
                                            </Typography>
                                            {parseParaDataText && (
                                                <Typography
                                                    component={'p'}
                                                    variant="paraText3"
                                                    sx={(theme) => ({
                                                        [theme.breakpoints.up('sm')]: {
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 5, // Limit to 4 lines
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        },

                                                        // minHeight: { xs: 'unset', sm: '115px' },
                                                        // maxHeight: { xs: 'unset', sm: '115px' },

                                                        '& ul': {
                                                            listStylePosition: 'inside',
                                                            marginLeft: '1rem',
                                                        },
                                                        '& a': {
                                                            // display: '-webkit-box',
                                                            // WebkitLineClamp: 1, // Limit to 2 lines
                                                            // WebkitBoxOrient: 'vertical',
                                                            // overflow: 'hidden',
                                                            // textOverflow: 'ellipsis',
                                                            // wordWrap: 'break-word',
                                                            // wordBreak: 'break-word',
                                                            whiteSpace: 'nowrap',
                                                            display: 'inline-block', // or 'block' for full-width anchors
                                                            color: '#434343',

                                                            '@media (min-width:1130px) and (max-width:1260px)': {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                width: '200px',
                                                            },
                                                            '@media (min-width:601px) and (max-width:670px)': {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                width: '200px',
                                                            },
                                                            '@media (min-width:0px) and (max-width:340px)': {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                width: '200px',
                                                            },
                                                        },
                                                    })}
                                                >
                                                    {parseParaDataText}
                                                </Typography>
                                            )}
                                        </Box>

                                        <Box
                                            marginTop={{ xs: '1rem', sm: '0.5rem' }}
                                            display={'flex'}
                                            justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                                            marginLeft={{
                                                xs: '-1rem',
                                                sm: '0rem',
                                            }}
                                        >
                                            <Link component={Button} variant="text" color="primary" href={cItem.hyperlink} target="_blank" rel="noopener" underline="none">
                                                {'Learn More'}
                                            </Link>
                                            {!cItem.hideSupportButton && (
                                                <Button variant="contained" color="primary" onClick={() => handleRequestSupport(cItem)}>
                                                    {'Request support'}
                                                </Button>
                                            )}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}

                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ padding: '1rem', marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
                        <Box>
                            <SpeakerIcon />
                        </Box>
                        <Typography component={'p'} variant="paraText1" textAlign={'start'} marginLeft={'1rem'}>
                            Want faster answers? Most common issues and questions are addressed in our{'  '}
                            <Typography
                                component={Link}
                                href="https://help.primecorporateservices.com"
                                target="blank"
                                variant="inherit"
                                color={'primary'}
                                sx={{
                                    cursor: 'pointer',
                                    textDecorationColor: 'inherit',
                                    '&:hover': {
                                        textDecoration: 'none',
                                    },
                                }}
                            >
                                Help Center
                            </Typography>
                            .
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>

            <Box sx={{ paddingTop: '2rem' }} />
        </MainContainer>
    );
}

export default CustomerSupport;
